<div class="wrapper">
    <ng-container *ngIf="showRecentActions">
        <app-search-recent-actions></app-search-recent-actions>
    </ng-container>
    <ng-container *ngIf="!showRecentActions">
        <ng-template #notFound>
            <div class="not-found">No items found</div>
        </ng-template>
        <div class="tabs">
            <div class="tab"
                [class.selected]="selectedTab == 'Orders'"
                (click)="selectedTab = 'Orders'">
                <span>Orders</span>
            </div>
            <div class="tab"
                [class.selected]="selectedTab == 'Accounts'"
                (click)="selectedTab = 'Accounts'">
                <span>Contacts</span>
            </div>
            <div class="tab"
                [class.selected]="selectedTab == 'Chat'"
                (click)="selectedTab = 'Chat'">
                <span>Chat Groups</span>
            </div>
            <div class="tab"
                [class.selected]="selectedTab == 'Products'"
                (click)="selectedTab = 'Products'">
                <span>Product</span>
            </div>
        </div>
        <ng-container>
            <div class="tabs-output"
                [ngSwitch]="selectedTab">
                <ng-container *ngIf="selectedTab === 'Orders'">
                    <ng-container>
                        <app-search-orders-view >
                        </app-search-orders-view>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="selectedTab === 'Accounts'">
                    <ng-container>
                        <app-search-accounts-view>
                        </app-search-accounts-view>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="selectedTab === 'Chat'">
                    <ng-container>
                        <app-search-chats-view >
                        </app-search-chats-view>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="selectedTab === 'Products'">
                    <ng-container>
                        <app-search-products-view>
                        </app-search-products-view>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
</div>